module.exports = __webpack_public_path__ + "img/receipt.9ed5d911.svg";